import api from './api'

export default {

    async getVersion() {
        return api.get('/api/Version');
    }
};